import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Features from "@/pages/Features";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/termek" element={<Product />} />
            <Route path="/funkciok" element={<Features />} />
            <Route path="/kapcsolat" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="light" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
